import $ from '../$';
import map from '../functions/map';
$.map = map;
